module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.35d57b5f.png";